<template>
  <v-dialog
    v-model="dialog"
    min-width="300"
    max-width="655"
    :style="{ zIndex: 200 }"
    @keydown.esc="cancel"
  >
    <v-card>
      <v-toolbar color="primary" dark>
        <v-toolbar-title>
          {{ $t("message.common.usage") }}
        </v-toolbar-title>
      </v-toolbar>
      <v-card class="d-flex justify-center mb-1 mt-1">
        <v-card flat class="pa-2">
          <v-select
            :label="$t('message.limit_usage.period')"
            :items="periods"
            item-text="label"
            item-value="value"
            v-model="period"
            hide-details
          >
            <template v-slot:item="props">
              {{ $t('message.limit_usage.period_' + props.item.label) }}
            </template>
            <template v-slot:selection="props">
              <v-list-item class="pa-2 pl-0" style="min-height:auto">
                {{ $t('message.limit_usage.period_' + props.item.label) }}
              </v-list-item>
            </template>
          </v-select>
        </v-card>
        <v-card flat class="pa-2">
          <v-select
            :label="$t('message.limit_usage.resource')"
            :items="resources"
            item-text="label"
            item-value="value"
            v-model="resource"
            hide-details
          >
            <template v-slot:item="props">
              {{ $t('message.limit_usage.resource_' + props.item.label) }}
            </template>
            <template v-slot:selection="props">
              <v-list-item class="pa-2 pl-0" style="min-height:auto">
                {{ $t('message.limit_usage.resource_' + props.item.label) }}
              </v-list-item>
            </template>
          </v-select>
        </v-card>
      </v-card>
      <v-card flat class="pt-1 pb-1 pr-3">
        <p class="text-right">
          <v-btn color="primary" @click.native="get_excel" :disabled="resource === ''">
            {{ $t("message.common.get_excel") }}
          </v-btn>
          <v-btn @click.native="cancel" ref="cancel">
            {{ $t("message.common.cancel") }}
          </v-btn>
        </p>
      </v-card>
    </v-card>
    <v-overlay
      :absolute="true"
      :value="progress_overlay"
    >
      <v-progress-circular
        :value="progress"
      >
        {{ progress }}
      </v-progress-circular>
    </v-overlay>
  </v-dialog>
</template>

<script>
import { http_error } from "../js/http_error";
import saveAs from "file-saver";
import XLSX from "xlsx";
import sanitize_filename from "sanitize-filename";
import 'xlsx.utils.sanitize_sheet_name';

export default {
  name: 'usage_list',
  mixins: [http_error],
  props: {
    module: String,
    id_name: String,
    mode: String
  },
  data: function(){
    return {
      module_id: "82",
      period: "hour",
      resource: "",
      data: null,
      periods: [
        {
          "label": "year",
          "value": "year"
        },
        {
          "label": "month",
          "value": "month"
        },
        {
          "label": "day",
          "value": "day"
        },
        {
          "label": "hour",
          "value": "hour"
        },
        {
          "label": "f_min",
          "value": "f_min"
        }
      ],
      resources: [],
      progress: 0,
      progress_overlay: false,
      dialog: false,
      resolve: null,
      reject: null,
    }
  },
  methods: {
    open(data) {
      this.data = data;
      if(data !== null){
        this.get_resource_index();
      }
      this.dialog = true;
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      })
    },
    get_excel() {
      this.dialog = false;
      var cur_data = [
        [
          "No.",
          this.$i18n.t("message.common." + this.id_name),
          this.$i18n.t("message.common.name")
        ]
      ];
      var max_data = [
        [
          "No.",
          this.$i18n.t("message.common." + this.id_name),
          this.$i18n.t("message.common.name")
        ]
      ];
      var date_index = this.get_date_index();
      for(var date of date_index){
        cur_data[0].push(this.$i18n.d(new Date(1000 * date), this.period, this.$store.getters.langs[this.$i18n.locale].locale));
        max_data[0].push(this.$i18n.d(new Date(1000 * date), this.period, this.$store.getters.langs[this.$i18n.locale].locale));
      }

      var promiseArray = [];
      var usage_index = {};
      for(var usage of this.data){
        var url = this.$store.getters.api_endpoint + "/" + this.get_prefix() + this.module + "/" + usage[this.id_name] + "/" + this.resource;
        usage_index[usage[this.id_name]] = usage;
        usage_index[usage[this.id_name]].cur = {};
        usage_index[usage[this.id_name]].max = {};
        for(var date of date_index){
          usage_index[usage[this.id_name]].cur[date] = 0;
          usage_index[usage[this.id_name]].max[date] = 0;
        }
        promiseArray.push(this.$http.get(url,
                                         {
                                           validateStatus: function (status) {
                                             return (status >= 200 && status < 300) || status == 404;
                                           }
                                         }));
      }
      var take_over = {
        cur_data: cur_data,
        max_data: max_data,
        usage_index: usage_index,
        parent: this
      };
      this.progress = 0;
      this.progress_overlay = true;
      Promise.all(promiseArray)
        .then(function(responses){
          for(var [index, response] of responses.entries()){
            this.parent.progress = parseInt( Math.round( ( index / Object.keys(this.usage_index).length ) * 100 ));
            if(response.status == 404){
              continue;
            }
            if(this.parent.$store.getters.debug){
              console.log("response.data:" + JSON.stringify(response.data));
            }
            for(var key in response.data){
              var value = response.data[key];
              var usage = this.usage_index[value[this.parent.id_name]];
              if((this.parent.period === "year" && key[0] === "y")
                || (this.parent.period === "month" && key[0] === "m")
                || (this.parent.period === "day" && key[0] === "d")
                || (this.parent.period === "hour" && key[0] === "h")
                || (this.parent.period === "f_min" && key[0] === "f")){
                usage.cur[value.utime] = value.cur;
                usage.max[value.utime] = value.max;
              }
            }
          }
          if(this.parent.$store.getters.debug){
            console.log(this.usage_index);
          }
          this.parent.progress = 100;
          this.parent.progress_overlay = false;

          var index = 1;
          for(var key in this.usage_index){
            var value = this.usage_index[key];
            var cur = [index, value[this.parent.id_name]];
            var max = [index, value[this.parent.id_name]];
            if(this.parent.module === "user" && value.name == null){
              cur.push("(" + value.user + ")");
              max.push("(" + value.user + ")");
            }else{
              cur.push(value.name);
              max.push(value.name);
            }
            for(var date of date_index){
              cur.push(this.parent.change_value(value.cur[date]));
              max.push(this.parent.change_value(value.max[date]));
            }
            this.cur_data.push(cur);
            this.max_data.push(max);
            index++;
          }

          // 以降はExcel処理
          var wb = XLSX.utils.book_new();

          if(this.parent.$store.getters.debug){
            console.log(this.cur_data);
          }
          var ws_name = this.parent.$i18n.t("message.limit_usage.cur");
          var ws = XLSX.utils.aoa_to_sheet(this.cur_data);
          /* Add the worksheet to the workbook */
          XLSX.utils.book_append_sheet(wb, ws, XLSX.utils.sanitize_sheet_name(ws_name));

          if(this.parent.$store.getters.debug){
            console.log(this.max_data);
          }
          var ws_name = this.parent.$i18n.t("message.limit_usage.max");
          var ws = XLSX.utils.aoa_to_sheet(this.max_data);
          /* Add the worksheet to the workbook */
          XLSX.utils.book_append_sheet(wb, ws, XLSX.utils.sanitize_sheet_name(ws_name));

          /* bookType can be any supported output type */
          var wopts = { bookType:'xlsx', bookSST:false, type:'binary' };
          var wbout = XLSX.write(wb,wopts);
          function s2ab(s) {
            var buf = new ArrayBuffer(s.length);
            var view = new Uint8Array(buf);
            for (var i=0; i!=s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
            return buf;
          }
          /* the saveAs call downloads a file on the local machine */
          var date = new Date();
          var date_str = ('0' + (date.getMonth() + 1)).slice(-2)
                       + ('0' + date.getDate()).slice(-2)
                       + ('0' + date.getHours()).slice(-2)
                       + ('0' + date.getMinutes()).slice(-2);
          saveAs(new Blob([s2ab(wbout)],{type:"application/octet-stream"}),
                 sanitize_filename(this.parent.$i18n.t("message.common." + this.parent.module) + this.parent.$i18n.t("message.common.usage") + "_" + this.parent.$i18n.t(`message.limit_usage.resource_${this.parent.resource}`) + "_" + date_str + ".xlsx"));

          this.parent.resolve(true);
        }.bind(take_over))
        .catch(error => {
          this.progress_overlay = false;
          if(this.http_error(error)){
            if(error.response.status !== 404){
              this.$store.commit("setNotification", {
                type: "error",
                message: error.response.data
              });
            }
          }
        })
    },
    cancel() {
      this.dialog = false;
      this.resolve(false);
      this.remove_range();
    },
    remove_range(){
      const selection = window.getSelection();
      if(selection.toString()){
        const range = selection.getRangeAt(0);
        selection.removeAllRanges(range);
      }
    },
    get_resource_index: function() {
      this.progress_overlay = true;
      this.progress = 0;
      this.$http.get(this.$store.getters.api_endpoint + "/" + this.get_prefix() + this.module + "/" + this.data[0][this.id_name] + "/resource",
                     {
                       onDownloadProgress: function( progressEvent ) {
                         this.progress = parseInt( Math.round( ( progressEvent.loaded / progressEvent.total ) * 100 ));
                       }.bind(this)
                     })
        .then( response => {
          this.progress = 100;
          this.progress_overlay = false;
          if(this.$store.getters.debug){
            console.log("response.data:" + JSON.stringify(response.data));
          }
          var resoures = [];
          for(var resource of response.data.upper){
            resoures.push({
              label: resource,
              value: resource
            });
          }
          this.resources = resoures;
          if(this.resource === ""){
            this.resource = this.resources[0].value;
          }
        })
        .catch( error => {
          this.progress_overlay = false;
          if(this.http_error(error)){
            this.$store.commit("setNotification", {
              type: "error",
              message: error.response.data
            });
          }
        });
    },
    get_date_index: function(){
      var result = [];
      var now = new Date();
      var year = now.getUTCFullYear();
      var month = now.getUTCMonth();
      var day = now.getUTCDate();
      var hour = now.getUTCHours();
      switch(this.period){
        case "year":
          // year: 5年分
          for(var y = year - 4; y <= year; y++){
            var t = new Date(Date.UTC(y, 0, 1, 0, 0, 0)).getTime() / 1000;
            result.unshift(t);
          }
          break;
        case "month":
          // month: 12ヶ月分
          for(var m = month + 1; m < 12; m++){
            var t = new Date(Date.UTC(year - 1, m, 1, 0, 0, 0)).getTime() / 1000;
            result.unshift(t);
          }
          for(var m = 0; m <= month; m++){
            var t = new Date(Date.UTC(year, m, 1, 0, 0, 0)).getTime() / 1000;
            result.unshift(t);
          }
          break;
        case "day":
          // day: 30日分
          var t = new Date(Date.UTC(year, month, day, 0, 0, 0)).getTime() / 1000;
          for(var d = t - 29 * 86400; d <= t; d += 86400){
            result.unshift(d);
          }
          break;
        case "hour":
          // hour: 24時間分
          var t = new Date(Date.UTC(year, month, day, hour, 0, 0)).getTime() / 1000;
          for(var h = t - 23 * 3600; h <= t; h += 3600){
            result.unshift(h);
          }
          break;
        case "f_min":
          // 5min: 1時間分
          var t = Math.floor(now.getTime() / 1000 / 300) * 300;
          for(var m = t - 11 * 300; m <= t; m += 300){
            result.unshift(m);
          }
          break;
      }
      return result;
    },
    get_prefix: function(){
      if(this.mode === "user"){
        return "";
      }else{
        return this.mode + "/";
      }
    },
    change_value(value) {
      if(this.resource === 'file_size') {
        return (value / 1024).toFixed(1);
      }
      else if(this.resource === 'model_size') {
        return (value / 1024 / 1024).toFixed(1);
      }
      else {
        return value;
      }
    }
  }
}
</script>
